import React from 'react';
import './IRCTVDonationCard.css';
import QR_IRC from '../images/QR_IRC.jpg'

// In IRCTVDonationCard.jsx - Add helper function to extract numbers
const extractNumber = (value) => {
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    // Remove currency symbols and commas, then parse
    const num = value.replace(/[^\d.-]/g, '');
    return parseFloat(num) || 0;
  }
  return 0;
};


const IRCTVDonationCard2 = ({
  donationLink = process.env.REACT_APP_P_URL,
  title = "Support IRC TV",
  subtitle = "Your donation makes a difference",
  description = "Donate Us continue spreading authentic Islamic knowledge and support our charitable activities worldwide.",
  baseAmount = 500,
  baseAmount2 = 15000,
  quantity = 1,
  onIncrease,
  onDecrease,
  onQuantityChange,
  totalAmount,
  purpose = "Cause: For IRC TV",
  purpose2 = "Cause: For IRC TV",
  buttonText = "Donate Now",
  behalf = "On behalf of :->",
  behalfdescription = "For the sake of Allah SWT",
  showQuantityControls = false,
  showDividedAmounts = false,
  showMainAmount = true,
  serviceType = "charity" // "charity", "dental", "pathology", "water", "food", "women"
}) => {

    // Convert string amounts to numbers
  const numericBaseAmount = extractNumber(baseAmount);
  const numericBaseAmount2 = extractNumber(baseAmount2);

  // Get service-specific labels and icons
  const getServiceDetails = () => {
    switch (serviceType) {
      case 'dental':
        return {
          unitLabel: 'dental treatments',
          icon: '🦷',
          color: '#3B82F6',
          perUnitText: 'per treatment'
        };
      case 'pathology':
        return {
          unitLabel: 'lab tests',
          icon: '🔬',
          color: '#10B981',
          perUnitText: 'per test'
        };
      case 'water':
        return {
          unitLabel: 'water jars',
          icon: '💧',
          color: '#06B6D4',
          perUnitText: 'per jar'
        };
      case 'food':
        return {
          unitLabel: 'people',
          icon: '🍽️',
          color: '#F59E0B',
          perUnitText: 'per person'
        };
      case 'women':
        return {
          unitLabel: 'women',
          icon: '🌟',
          color: '#8B5CF6',
          perUnitText: 'per student (3 months)'
        };
      default: // charity
        return {
          unitLabel: 'patient',
          icon: '🤝',
          color: '#ED1636',
          perUnitText: 'per patient'
        };
    }
  };

  const serviceDetails = getServiceDetails();

  const handleDonateClick = (e) => {
    if (!donationLink) {
      e.preventDefault();
      alert('Donation link not configured');
    }
  };

  // Dynamic action verb based on service type
  const getActionVerb = () => {
    switch (serviceType) {
      case 'food': return 'feed';
      case 'women': return 'empower';
      case 'charity': return 'support';
      case 'dental': return 'treat';
      case 'pathology': return 'test';
      case 'water': return 'provide water to';
      default: return 'support';
    }
  };

  return (
    <div className="donation-container">
      <div className="donation-card">
        <div className="donation-content">
          {/* Left Section - Header and Description */}
          <div className="donation-info">
            <div className="donation-header">
              <div className="service-icon">
                <span className="icon-emoji">{serviceDetails.icon}</span>
              </div>
              <h3>{title}</h3>
              <p className="donation-subtitle">{subtitle}</p>
            </div>

            <p className="donation-cause">
              {description}
              <p className="donation-subtitle">{behalf} {behalfdescription}</p>
            </p>
          </div>

          {/* Right Section - Amount and CTA */}
          <div className="donation-action">
            {/* Quantity Controls */}
            {showQuantityControls && (
              <div className="quantity-section">
                <div className="quantity-controls">
                  <label className="quantity-label">
                    Number of {serviceDetails.unitLabel} to {getActionVerb()}
                  </label>
                  <div className="quantity-input-group">
                    <button
                      className="quantity-btn decrease"
                      onClick={onDecrease}
                      aria-label="Decrease quantity"
                      style={{ borderColor: serviceDetails.color }}
                    >
                      −
                    </button>
                    <input
                      type="number"
                      className="quantity-input"
                      value={quantity}
                      onChange={onQuantityChange}
                      min="1"
                      aria-label="Quantity"
                    />
                    <button
                      className="quantity-btn increase"
                      onClick={onIncrease}
                      aria-label="Increase quantity"
                      style={{ borderColor: serviceDetails.color }}
                    >
                      +
                    </button>
                  </div>
                  <div className="amount-breakdown">
                    <span className="per-person">
                      {quantity} × ₹{baseAmount} {serviceDetails.perUnitText}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {/* Main Amount Display */}
            {showMainAmount && (
              <div
                className="donation-amount-card"
                style={{
                  background: `linear-gradient(135deg, ${serviceDetails.color}15, ${serviceDetails.color}25)`,
                  borderColor: `${serviceDetails.color}40`
                }}
              >
                <div className="amount-badge">
                  <span
                    className="amount-label"
                    style={{ color: serviceDetails.color }}
                  >
                    Total Donation Amount
                  </span>
                  <div className="amount-values">
                    <span
                      className="amount"
                      style={{ color: serviceDetails.color }}
                    >
                      ₹{totalAmount || (quantity * numericBaseAmount)}
                    </span>
                    <span
                      className="amount-purpose"
                      style={{ color: serviceDetails.color }}
                    >
                      {purpose}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {/* Main Amount Display */}
            {showMainAmount && (
              <div
                className="donation-amount-card"
                style={{
                  background: `linear-gradient(135deg, ${serviceDetails.color}15, ${serviceDetails.color}25)`,
                  borderColor: `${serviceDetails.color}40`
                }}
              >
                <div className="amount-badge">
                  <span
                    className="amount-label"
                    style={{ color: serviceDetails.color }}
                  >
                    Total Donation Amount
                  </span>
                  <div className="amount-values">
                    <span
                      className="amount"
                      style={{ color: serviceDetails.color }}
                    >
                      ₹{totalAmount || (quantity * numericBaseAmount2)}
                    </span>
                    <span
                      className="amount-purpose"
                      style={{ color: serviceDetails.color }}
                    >
                      {purpose2}
                    </span>
                  </div>
                </div>
              </div>
            )}

            {/* Divided Amounts (if needed) */}
            {showDividedAmounts && (
              <div className="divided-amounts">
                {/* Your divided amounts content here */}
              </div>
            )}

            {/* Donate Button */}
            <a
              href={donationLink}
              className="donate-btn"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleDonateClick}
              style={{
                background: serviceDetails.color,
                boxShadow: `0 4px 15px ${serviceDetails.color}30`
              }}
            >
              <span className="btn-text">{buttonText}</span>
              <span className="btn-arrow">→</span>
            </a>

            <div className="qr-box">
              <p className="qr-text">Pay Via QR Code</p>
              <img src={QR_IRC} alt="QR Code" className="qr-code" />
              <p className="qr-text">UPI ID: IRCEWT@SBI</p>
            </div>

            <div className="security-badge">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM12 11.99H19C18.47 16.11 15.72 19.78 12 20.93V12H5V6.3L12 3.19V11.99Z" fill="currentColor" />
              </svg>
              <span>Secure & Encrypted</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IRCTVDonationCard2;